<div class="fg-view-container fg-with-header">
  <div class="tab-menu fg-view-header">
    <router-tabs [routes]="routes"></router-tabs>
  </div>
  <router-outlet></router-outlet>
</div>
